import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';

// Async thunk to fetch user payslips
export const fetchUserPayslips = createAsyncThunk(
  'payslips/fetchUserPayslips',
  async (email, { rejectWithValue }) => {
    try {
      // Query payslips collection for documents matching user email
      const payslipsRef = collection(db, 'payslips');
      const q = query(payslipsRef, where('email', '==', email));
      const querySnapshot = await getDocs(q);
      
      // Convert query snapshot to array of payslip data
      const payslips = [];
      querySnapshot.forEach((doc) => {
        payslips.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      // Sort payslips by date (newest first)
      payslips.sort((a, b) => {
        const dateA = a.createdAt?.toDate?.() || new Date(0);
        const dateB = b.createdAt?.toDate?.() || new Date(0);
        return dateB - dateA;
      });
      
      return payslips;
    } catch (error) {
      console.error('Error fetching payslips:', error);
      return rejectWithValue(error.message);
    }
  }
);

const payslipSlice = createSlice({
  name: 'payslips',
  initialState: {
    items: [],
    loading: false,
    error: null
  },
  reducers: {
    clearPayslips: (state) => {
      state.items = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPayslips.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPayslips.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchUserPayslips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearPayslips } = payslipSlice.actions;
export default payslipSlice.reducer; 